var Redux, cards, games, rootReducer, user;

Redux = require('redux');

cards = require('./cards');

games = require('./games');

user = require('./user');

rootReducer = Redux.combineReducers({
  cards: cards,
  user: user,
  games: games
});

module.exports = rootReducer;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/reducers/index.coffee
 ** module id = 280
 ** module chunks = 0
 **/